import React from 'react'

import NavigationMenu from './NavigationMenu'

import classes from './Navigation.module.scss'

const normalizeMenuStructure = (items = []) =>
  items.reduce((menu, item) => {
    const menuItem = {
      ...item,
      path: item.path,
    }

    if (menu.length > 0 && item.isNested) {
      const parentItem = items.find(o => o.path == item.path.split('#')[0])
      if (!parentItem.submenu) parentItem.submenu = []

      if (!parentItem.submenu.some(el => el.path === item.path)) parentItem.submenu.push(menuItem)
    } else {
      menu.push(menuItem)
    }

    return menu
  }, [])

const moveMenuItems = (menuItems, from, to) => {
  menuItems.splice(to, 0, menuItems.splice(from, 1)[0])
  return menuItems
}
class Navigation extends React.Component {
  render() {
    const { currentPath, navigation } = this.props

    const menuItems = normalizeMenuStructure(navigation).reverse()

    // Re-Ordering Specific Menu Items To Maintain Original Order Of Navigation Menu As Compare To Slim Page Menu
    moveMenuItems(menuItems, 4, 4)
    moveMenuItems(menuItems, 10, 3)

    return (
      <div className={classes.menu}>
        <NavigationMenu items={menuItems} active={currentPath} />
      </div>
    )
  }
}

export default Navigation
